export const KnittingBelt = () => {
    return <h1>KnittingBelt</h1>
}